export default "__VITE_ASSET__svdJmiTi__"